import React, { Component } from "react";
import { connect } from "react-redux";

// Components
import AccountBtns from "./AccountBtns";
import CheckoutBtn from "./CheckoutBtn";
import CartQtyBtn from "./CartQtyBtn";

// CSS
import "./../../css/header.css";

class Header extends Component {
	render() {
		return (
			<div className="headerbar">
				<nav className="body_container">
					<AccountBtns user={this.props.user} />
					<div className="cart_section">
						<ul>
							<CartQtyBtn cart={this.props.cart} />
							<CheckoutBtn cart={this.props.cart} />
						</ul>
					</div>
				</nav>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		cart: state.cart
	};
};

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/header/HeaderBar.js